/**
 * Created by buddy on 2020-08-11.
 */
import { createContext } from 'react';

export const ChangeContext = createContext(null);
